module.exports = __webpack_public_path__ + "img/background_c3-1-2_mobile.175456ef.jpeg";